<div
  *ngIf="current_store_logo && current_store_logo != 'icon.png'"
  (click)="logo_click.emit()"
  [ngStyle]="{ 'background-image': 'url(' + getStoreLogo() + ')' }"
  [ngClass]="getSizeClass()"
  class="sp-background__center-cover sp-cursor__pointer"></div>

<div
  *ngIf="!current_store_logo || current_store_logo == 'icon.png'"
  (click)="logo_click.emit()"
  [ngStyle]="{ 'background-image': 'url(' + logo_placeholder_src + ')' }"
  [ngClass]="getSizeClass()"
  class="sp-background__center-cover sp-cursor__pointer"></div>
